<h4 *ngIf="displayTitle" class="mat-h5 mg-summary-section-header">
  {{ title }}
</h4>
<div class="mg-summary-body">
  <div class="mg-summary-row mat-body" *ngFor="let item of items">
    <h5 [ngClass]="item?.isBold ? 'text-bold' : ''">{{ item?.name }}<sup *ngIf="item?.supNumber">{{item.supNumber}}</sup></h5>
    <p [ngClass]="item?.isBold ? 'text-bold' : ''">
      {{ item?.displayMinus ? "-" : "" }}{{ item?.value }}
      {{ item?.sendCurrency }}
    </p>
  </div>
</div>
